import axios, { AxiosRequestConfig } from 'axios'

class ShipmentsReportService {
    // Get a shipping order report
    async getShippingOrderReport(
        laboratoryId: number,
        shipmentId: number,
        /**
         * For printing: true, for downloading: false.
         * When encoded is true, Pdf binary file is encoded in base64.
         * It is necessary to send file to AnapathPrinter service correctly.
         */
        encoded: boolean
    ): Promise<Blob> {
        const config: AxiosRequestConfig = {
            params: { encoded },
            headers: { type: 'application/pdf' },
            responseType: encoded ? 'text' : 'arraybuffer'
        }
        const response = await axios.get<Blob>(
            `/shipments/laboratories/${laboratoryId}/shipments/${shipmentId}/report`,
            config)
        return response.data
    }
}

export const shipmentsReportService = new ShipmentsReportService()
